import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TitleCaseAndCleanPipeModule } from '@fleet/pipes';
import { NetworkGroupSelectorComponent } from './network-group-selector.component';

@NgModule({
  declarations: [NetworkGroupSelectorComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    TitleCaseAndCleanPipeModule,
  ],
  exports: [NetworkGroupSelectorComponent],
})
export class NetworkGroupSelectorModule {}
